import { useContext } from "react";
import { DrawerContext } from "./DrawerContext";

export const useDrawer = () => {
  const { onClose, closeLabel, headerId } = useContext(DrawerContext);

  return { onClose, closeLabel, headerId };
};
